import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';

// Estilos para el documento PDF
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
});

const MyDocument = () => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text>Sección #1</Text>
            </View>
            <View style={styles.section}>
                <Text>Sección #2</Text>
            </View>
        </Page>
    </Document>
);

const modeloDatos = {
    doctorID: 0,
    empresaID: 1,
    nombreDoctor: "",
    telefono: "",
     especialidadID: 1,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    porcientoAcionista: 0.00,
    porcientoReferido: 0.00,
    porcientoTecnico: 0.00,
    porcientoAyudante:0.00

}

const Seguros = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [reportUrl, setReportUrl] = useState(null);
    const [Listado1, SetListado1] = useState([]);

    const fetchReport = async () => {
        const response = await fetch(Api + "Pacientes/getreport");
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        setReportUrl(url);
    };


    const onBusqueda = async (e) => {
        var l = Listado1;

        var searchData = l.filter((item) => {
            if (
                (item.nombreDoctor + item.doctorID + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())

            ) {
                return item;
            }
        });
        SetListado(searchData);
    };


    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "CMantenimiento/listaDoctores/" + JSON.parse(user).correo);
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
        if (pendiente ) {
                SetListado(data);
                setPendiente(false)
            }
        }
    }

    useEffect(() => {
        obtenerDatos();
    })


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.doctorID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            tabla.empresaID = JSON.parse(user).empresaID;
          
            if (!navigator.onLine) {
                localStorage.setItem("pendiente", JSON.stringify(tabla));
            } else {
                response = await fetch(Api + "CMantenimiento/GuardarDoctores", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })
            }
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "CMantenimiento/EditarDoctores", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }
    window.addEventListener('online', () => {
        const data = JSON.parse(localStorage.getItem("pendiente"));
        if (data) {
            fetch(Api + "CMantenimiento/GuardarDoctores", {
                method: "POST",
                body: JSON.stringify(data),
                headers: { "Content-Type": "application/json" }
            }).then(() => localStorage.removeItem("pendiente"));
            localStorage.removeItem("pendiente")
        }
    });
    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.doctorID,
            sortable: true,
        },
        {
            name: 'Nombre ',
            selector: row => row.nombreDoctor,
            sortable: true,
        },      {
            name: 'Telefono ',
            selector: row => row.telefono,
            sortable: true,
        },


       
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <div hidden>
                <h1>Generar Reporte PDF</h1>
                <PDFDownloadLink document={<MyDocument />} fileName="reporte.pdf">
                    {({ loading }) => (loading ? 'Generando documento...' : 'Descargar PDF')}
                </PDFDownloadLink>
            </div>
            <div hidden>
                <button onClick={fetchReport}>Ver Reporte</button>
                {reportUrl && (
                    <iframe src={reportUrl} width="100%" height="600px"></iframe>
                )}
            </div>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Doctores
                </CardHeader>
                <CardBody>
                    <Row>
                    <Col md="2">
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Doctor</Button>
                    </Col> <Col>
                        <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de doctores " ></Input>
                        </Col>
                        </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader className="modal-header1">
                    Mantenimiento de Doctor
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Nombre Doctor </Label>
                                <Input bsSize="sm" name="nombreDoctor" onChange={handleChange} value={tabla.nombreDoctor} />
                            </FormGroup>
                        </Col>

                    
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Telefono</Label>
                                <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />

                            </FormGroup>
                        </Col>
                        <Col hidden sm={4}>
                            <FormGroup>
                                <Label>Especialidad</Label>
                                <Input bsSize="sm" name="especialidadID" onChange={handleChange} value={tabla.especialidadID} />

                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={3}>
                            <FormGroup>
                                <Label>Porciento Acionista</Label>
                                <Input bsSize="sm" name="porcientoAcionista" onChange={handleChange} value={tabla.porcientoAcionista} />
                            </FormGroup>
                        </Col>
                        <Col sm={3}>
                            <FormGroup>
                                <Label>Porciento Referido</Label>
                                <Input bsSize="sm" name="porcientoReferido" onChange={handleChange} value={tabla.porcientoReferido} />
                            </FormGroup>
                        </Col>
                          <Col sm={3}>
                            <FormGroup>
                                <Label>Porciento Tecnico</Label>
                                <Input bsSize="sm" name="porcientoTecnico" onChange={handleChange} value={tabla.porcientoTecnico} />
                            </FormGroup>
                        </Col>
                             <Col sm={3}>
                            <FormGroup>
                                <Label>Porciento Tecnico</Label>
                                <Input bsSize="sm" type="number" name="porcientoAyudante" onChange={handleChange} value={tabla.porcientoAyudante} />
                            </FormGroup>
                        </Col>

                       

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Seguros;